import {Pipe, PipeTransform} from '@angular/core';
// TODO(RZ-2562): Replace legacy VO types (AuthPolicyVO, PolicyConfigVO, PolicyUserVO) with SDK equivalents
import {AuthPolicyVO, PolicyConfigVO, PolicyPermissionVO, PolicyType, PolicyUserVO} from '../../../../generate/TopLevelDomainVO';

@Pipe({
    name: 'authPolicyEditHelper',
    standalone: false
})
export class AuthPolicyEditHelperPipe implements PipeTransform {

  transform(value: any, type?: string, arg1?: any): any {
    switch (type) {
      case 'permission':
        return this.retrievePermission(value, arg1);
      case 'policy': {
        return this.retrievePolicy(value, arg1);
      }

    }
    return null;
  }

  private retrievePermission(value: PolicyPermissionVO[], arg1: PolicyType) {
    let policyPermissionVO: PolicyPermissionVO = value.filter(permission => permission.policyType === arg1).pop();
    return policyPermissionVO.permission === 'Approve';
  }

  private retrievePolicy(authPolicyVO: AuthPolicyVO, policyType: PolicyType) {
    const value = authPolicyVO.policies;
    let policyConfigVO: PolicyConfigVO = value.filter(policyConfigVO => policyConfigVO.policyType === policyType).pop();
    let policyThreshold = policyConfigVO.policyThreshold;
    const maxLimit = this.getMaxLimitForRequestType(policyType, authPolicyVO.users);

    if (policyThreshold.thresholdType === 'All') {
      policyThreshold.limit = maxLimit;
    } else if (policyThreshold.thresholdType === 'Majority') {
      if (maxLimit > 1) {
        policyThreshold.limit = Math.ceil(maxLimit / 2);
      } else {
        policyThreshold.limit = maxLimit;
      }
    }

    policyThreshold.maxLimit = maxLimit;
    policyConfigVO.policyThreshold = policyThreshold;

    return policyConfigVO;
  }

  public getMaxLimitForRequestType(policyType: PolicyType, users: PolicyUserVO[]) {
    let maxLimit = 0;
    for (const user of users) {
      for (const tldPermission of user.permissions) {
        if (tldPermission.policyType === policyType && tldPermission.permission === 'Approve') {
          maxLimit++;
        }
      }
    }

    return maxLimit;
  }
}
